<template>
  <Modal
    :active.sync="showModal"
    title="Novo Modelo de Foto"
    @close="closeModal"
  >
    <div class="vx-row mb-6">
      <div class="vx-col w-1/2">
        <span>Nome da Foto</span>
        <vs-input
          type="text"
          size="large"
          class="w-full"
          name="Nome da Foto"
          id="Nome da Foto"
          v-model="form.nomePosicao"
          v-validate="{ required: true }"
          :state="validateState('Nome da Foto')"
          :class="validateStateClass('Nome da Foto')"
        ></vs-input>
      </div>
      <div class="vx-col w-1/2">
        <span>Tipo da Foto</span>
        <v-select
          :options="tiposFotos"
          :reduce="(item) => item.id"
          v-model="form.idTipoFipe"
        ></v-select>
      </div>
    </div>
    <DragAndDropFileInput
      texto="Arraste suas imagens aqui ou clique abaixo para fazer o upload"
      :extensoesPermitidas="'png-jpg-jpeg-gif'"
      @files="handleFiles"
    />

    <vs-card class="mt-4">
      <div class="flex flex-col items-center gap-2">
        <h5>Use imagens de 500 x 300 pixels</h5>
        <img v-if="image" class="imagem" :src="image" />
      </div>
    </vs-card>

    <ErrorsAlert :errors="errors" />

    <div class="flex justify-end">
      <div class="flex gap-3">
        <vs-button color="warning" @click="removeFoto">Descartar</vs-button
        ><vs-button color="success" @click="validate">Upload</vs-button>
      </div>
    </div>
  </Modal>
</template>
<script>
import DragAndDropFileInput from '../../components/file-upload/upload-dragdown.vue';
import vSelect from 'vue-select';
import notify from '../../utils/notify';
import ErrorsAlert from '../../components/ErrorsAlert.vue';

import services from '../../services';
import utilsList from '../../utils/list';
import Modal from '../../components/Modal.vue';

export default {
  name: 'ModalNovoModeloFoto',
  components: {
    DragAndDropFileInput,
    'v-select': vSelect,
    ErrorsAlert,
    Modal
  },
  props: ['active'],
  watch: {
    active() {
      if (this.active) {
        this.showModal = this.active;
      }
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  data() {
    const tiposFotos = [
      { id: undefined, label: 'Geral' },
      { id: 1, label: 'Carro' },
      { id: 2, label: 'Moto' },
      { id: 3, label: 'Caminhão' },
    ];
    return {
      tiposFotos,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      showModal: false,
      image: null,
      files: [],
      form: {
        nomePosicao: null,
        fotoPadrao: null,
        idTipoFipe: null,
      },
    };
  },
  methods: {
    removeFoto() {
      this.image = null;
      this.files = [];
    },
    handleFiles(files) {
      const render = new FileReader();
      render.onload = (e) => (this.image = e.target.result);
      render.readAsDataURL(files[0]);
      this.files = files;
    },
    async validate() {
      const valid = await this.$validator.validateAll();
      const filesNumber = this.files.length;

      if (!filesNumber) {
        notify.notifyFail(this.$vs, 'Escolha uma imagem para fazer upload!');
        return;
      }

      valid && this.uploadAWS();
    },
    async uploadAWS() {
      try {
        const formDataSend = new FormData();
        formDataSend.append('file', this.files[0]);

        this.$vs.loading();

        const res = await services.upload(
          'upload',
          'images-padrao',
          formDataSend,
        );

        this.form.fotoPadrao = res.key;

        await this.salvarFoto();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async salvarFoto() {
      try {
        this.$vs.loading();
        const { data } = await services.post(
          'TipoFoto',
          'salvar-foto',
          this.form,
        );
        this.closeModal();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    closeModal() {
      this.showModal = false;
      this.$emit('close', this.form.nomePosicao);
    },
  },
};
</script>
<style>
.image-container {
  width: 500px;
  height: 300px;
}
</style>
